//Generated File 
export default class SaveBehavior{
	static readonly DoNotSave = `DoNotSave`;
	static readonly SaveAndCommit = `SaveAndCommit`;
	static readonly SaveAsDraft = `SaveAsDraft`;
}
